<script>
import appConfig from "@/app.config";
import polo from "@/components/polo";
import DatatablePaginationTotais from "@/components/widgets/datatable-pagination-totais.vue"

/**
 * Wallets component
 */
export default {
  page: {
    title: "Repasse",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DatatablePaginationTotais,
  },
  data() {
    return {
      chart: false,
      emails: [
        // "adriana.batista@multivix.edu.br",
        // "renata.fortes@multivix.edu.br",
      ],
      cronogramaRepasse: [

      ],
      OveviewChart: {
        series: [
          {
            type: "area",
            name: "Total",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 240,
            type: "line",
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
            dashArray: [0, 0, 3],
          },
          fill: {
            type: "solid",
            opacity: [0.15, 0.05, 1],
          },
          xaxis: {
            categories: [],
          },
          colors: ["#008000"],
        },
      },
      loadingAnalitico: false,
      polo: polo,
      modalAnalitico: false,
      datatableItems: [],
      title: "Repasse",
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Financeiro",
          //href: "/",
        },
        {
          text: "Repasse",
          active: true,
        },
      ],
      periodos: [],
      periodo: {},
      repasse: {
        master: {
          total: 0,
          totalLabel: "R$ 0,00",
          polos: [],
        },
        gastos: {
          total: 0,
          totalLabel: "R$ 0,00",
          itens: [],
        },
        complemento: {
          total: null
        },
      },
      carregando: {
        periodo: false,
        repasse: false,
      },
      mensagem: null,
      temRepasse: true,
      mostrarRepasse: false,
      semPeriodo: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "nivelEnsino",
          label: "Nível de Ensino",
          sortable: true,
        },
        {
          key: "ra",
          label: "RA",
          sortable: true,
        },
        {
          key: "ra",
          label: "RA",
          sortable: true,
        },
        {
          key: "aluno",
          label: "Aluno",
          sortable: true,
        },
        {
          key: "tipoDocumento",
          label: "Tipo de Documento",
          sortable: true,
        },
        {
          key: "competencia",
          label: "Competência",
          sortable: true,
        },
        {
          key: "dataVencimento",
          label: "Vencimento",
          sortable: true,
        },
        {
          key: "dataBaixa",
          label: "Baixa",
          sortable: true,
        },
        {
          key: "valorBruto",
          label: "Valor Bruto",
          sortable: true,
        },
        {
          key: "valorBaixado",
          label: "Valor Baixado",
          sortable: true,
        },
        {
          key: "dataMatricula",
          label: "Matrícula",
          sortable: true,
        },
        {
          key: "codperlet",
          label: "Codperlet",
          sortable: true,
        },
        {
          key: "situacao",
          label: "Situação",
          sortable: true,
        },
        {
          key: "parcela",
          label: "Parcela",
          sortable: true,
        },
        {
          key: "turmaEad",
          label: "Turma EAD",
          sortable: true,
        },
        {
          key: "idlan",
          label: "IDLan",
          sortable: true,
        },
        {
          key: "faixa",
          label: "Faixa",
          sortable: true,
        },
        {
          key: "porcentagem",
          label: "Porcentagem",
          sortable: true,
        },
        {
          key: "valor",
          label: "Valor",
          sortable: true,
        },
        {
          key: "quantidade",
          label: "Quantidade",
          sortable: true,
        },
        {
          key: "100%",
          label: "100%",
          sortable: true,
        },
        {
          key: "repasse",
          label: "Repasse",
          sortable: true,
        },
        {
          key: "custo",
          label: "Custo",
          sortable: true,
        },
        {
          key: "total",
          label: "Total",
          sortable: true,
        },
        {
          key: "historico",
          label: "Histórico",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.datatableItems.length;
    },
    sizeCol() {
      if (
        this.repasse.master.polos.length > 0 &&
        this.repasse.gastos.itens.length > 0
      )
        return 3;
      else if (
        this.repasse.master.polos.length > 0 &&
        this.repasse.gastos.itens.length == 0
      )
        return 4;
      else if (
        this.repasse.master.polos.length == 0 &&
        this.repasse.gastos.itens.length > 0
      )
        return 4;
      else return 6;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.datatableItems.length;
    this.getPeriodos();
    this.getPrazos();
    this.getMensagem()
    this.getEmails()
  },
  methods: {
    analitico(codCampus) {
      this.modalAnalitico = true;
      this.filter = "";
      this.datatableItems = [];
      this.currentPage = 1;
      this.loadingAnalitico = true;
      let payload = {
        dataInicio: this.periodo.dataInicio,
        dataFim: this.periodo.dataFim,
        codCampus: codCampus,
      };
      this.$axios
        .get(
          process.env.VUE_APP_API_URL + "/api/financeiro/repasse/analitico",
          {
            params: payload,
            headers: this.$headers,
          }
        )
        .then((response) => {
          this.loadingAnalitico = false;
          this.datatableItems = response.data;
          this.totalRows = response.data.length;
        })
        .catch((error) => {
          this.loadingAnalitico = false;
          this.$axiosCatch(error);
        });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getPeriodos() {
      this.carregando.periodo = true;
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/financeiro/repasse/datas", {
          params: {
            codCampus: this.polo.codCampus,
          },
          headers: this.$headers,
        })
        .then((response) => {
          this.carregando.periodo = false;
          if (response.data.length > 0) this.periodos = response.data;
          else this.temRepasse = false;
        })
        .catch((error) => {
          this.carregando.periodo = false;
          this.$axiosCatch(error);
        });
    },
    getPrazos() {
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/financeiro/repasse/prazos", {
          headers: this.$headers
        })
        .then((response) => {
          this.cronogramaRepasse = response.data
        })
        .catch((error) => {
          this.$axiosCatch(error)
        });
    },
    getMensagem() {
      const url = process.env.VUE_APP_API_URL + "/api/financeiro/repasse/mensagem"
      const headers = this.$headers
      this.$axios.get(url, { headers })
        .then(res => this.mensagem = res.data.mensagem)
    },
    getEmails() {
      const url = process.env.VUE_APP_API_URL + "/api/financeiro/repasse/emails"
      const headers = this.$headers
      this.$axios.get(url, { headers })
        .then(res => this.emails = res.data)
    },
    buscarRepasse() {
      this.chart = false;
      this.mostrarRepasse = false;
      this.carregando.repasse = true;
      this.OveviewChart.series[0].data = [];
      this.OveviewChart.chartOptions.xaxis.categories = [];
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/financeiro/repasse", {
          params: {
            codCampus: this.polo.codCampus,
            dataInicio: this.periodo.dataInicio,
            dataFim: this.periodo.dataFim,
          },
          headers: this.$headers,
        })
        .then((response) => {
          this.chart = true;
          this.carregando.repasse = false;
          this.mostrarRepasse = true;
          this.repasse = response.data;
          // if (response.data.master?.polos?.length > 0)
          // {
          //   this.datatableItems = response.data.master.polos;
          //   this.OveviewChart.chartOptions.xaxis.categories = response.data.master.polos.map((polo) => {
          //     return polo.polo
          //   });
          //   this.OveviewChart.series[0].data = response.data.master.polos.map((polo) => {
          //     return polo.total
          //   });
          // }
        })
        .catch((error) => {
          this.$axiosCatch(error);
          this.carregando.repasse = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
  <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <b-form v-if="temRepasse">
          <div v-if="carregando.periodo">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Buscando períodos
          </div>
            <div class="mb-3 row" v-else>
              <label class="col-md-2 col-form-label">Selecione o período</label>
              <div class="col-md-10">
                <select class="form-control" v-model="periodo" @change="buscarRepasse" :disabled="carregando.repasse">
                  <option v-for="(row, index) in periodos" :key="index" v-bind:value="row">
                    {{ row.label }}
                  </option>
                </select>
                <i v-if="carregando.repasse" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              </div>
            </div>
          </b-form>
          <div v-else role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
            Nenhum lançamento de repasse financeiro encontrado.
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="mostrarRepasse">
      <div class="col-lg-12">
        <b-alert v-show="mensagem" show variant="danger"><p v-html="mensagem"></p></b-alert>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ repasse.descricao }}</h4>
            <p v-if="repasse.status == 'AUTORIZADO'" class="card-title-desc">
              Status:
              <span class="badge badge-soft-success font-size-12 me-1"><strong>{{ repasse.status }}</strong></span>
            </p>
            <p v-else class="card-title-desc">
              Status:
              <span v-if="repasse.status == 'AUTORIZADO'" class="badge badge-soft-success font-size-12 me-1">
                <strong>{{ repasse.status }}</strong>
              </span>
              <span v-else class="badge badge-soft-danger font-size-12 me-1">
                <strong>{{ repasse.status }}</strong>
              </span>
            </p>

            <div class="row">
              <div class="col-lg-12 align-self-center">
                <div class="text-lg-center mt-4 mt-lg-0">
                  <div class="row">
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          Matriculados
                        </p>
                        <h6 class="mb-0">{{ repasse.totalMatriculados }}</h6>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">Percentual</p>
                        <h6 class="mb-0">{{ repasse.valorPercentual }}%</h6>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">Graduação</p>
                        <h6 class="mb-0">{{ $conversorMoeda(repasse.graduacao) }}</h6>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">Pós</p>
                        <h6 class="mb-0">{{ $conversorMoeda(repasse.posGraduacao) }}</h6>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">100%</p>
                        <h6 class="mb-0">{{ $conversorMoeda(repasse.repasse100) }}</h6>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">Faixa</p>
                        <h6 class="mb-0">{{ $conversorMoeda(repasse.repasseFaixa) }}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-lg-12 align-self-center">
                <div class="text-lg-center mt-4 mt-lg-0">
                  <div class="row">
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">Total Polo</p>
                        <h4 class="mb-0">
                          <span class="badge badge-soft-info">{{
                            $conversorMoeda(repasse.totalRepasse)
                          }}</span>
                        </h4>
                      </div>
                    </div>
                    <div class="col" v-show="repasse.master.polos.length > 0">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          Total Polos Master
                        </p>
                        <h4 class="mb-0">
                          <span class="badge badge-soft-info">{{
                            $conversorMoeda(repasse.master.total)
                          }}</span>
                        </h4>
                      </div>
                    </div>
                    <div class="col" v-show="repasse.gastos.itens.length > 0">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          Total Gastos
                        </p>
                        <h4 class="mb-0">
                          <span class="badge badge-soft-danger">{{
                            $conversorMoeda(repasse.gastos.total)
                          }}</span>
                        </h4>
                      </div>
                    </div>
                    <div class="col">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          Total Líquido para faturamento
                        </p>
                        <h4 class="mb-0">
                          <span class="badge badge-soft-success">{{
                            $conversorMoeda(repasse.totalParaFaturar)
                          }}</span>
                        </h4>
                      </div>
                    </div>
                    <div class="col" v-show="repasse.complemento.total">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          Valor Complementar
                        </p>
                        <h4 class="mb-0">
                          <span class="badge badge-soft-success">{{
                            $conversorMoeda(repasse.complemento.total)
                          }}</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <div class="row">
              <div class="button-items">
                <div class="btn">
                  <button type="button" class="btn btn-primary" v-b-modal.modal-financeiro-repasse-dadosfaturamento>
                    <i class="far fa-file-alt d-block font-size-16"></i>
                    Dados para Faturamento
                  </button>
                </div>
                <b-modal id="modal-financeiro-repasse-dadosfaturamento" size="lg" title="Dados para faturamento"
                  title-class="font-18" hide-footer>
                  <div class="card-body">
                    <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success">
                      <h4 class="text-center">
                        Total liquido para faturamento:
                        {{ $conversorMoeda(repasse.totalParaFaturar) }}
                      </h4>
                    </div>
                    <h5>Cronograma para repasse</h5>
                    <div class="table-responsive">
                      <table class="table table-sm mb-0">
                        <thead>
                          <tr>
                            <th>Envio da NF</th>
                            <th>Pagamento</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="c in cronogramaRepasse" :key="c">
                            <td>{{ c.envioNF }}</td>
                            <td>{{ c.pagamento }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <h5>
                      Encaminhar NF para todos os e-mails abaixo, juntamente com
                      os dados bancários:
                    </h5>
                    <p v-for="e in emails" :key="e">
                      <a :href="'mailto:' + e.email">{{ e.email }}</a>
                    </p>
                    <h5>Informar dados bancários conforme segue:</h5>
                    <p>
                      BANCO:<br />
                      NÚMERO DA AGÊNCIA (sem dígito):<br />
                      CONTA CORRENTE (com dígito):<br />
                      NOME COMPLETO (RAZÃO SOCIAL) DO TITULAR DA CONTA CORRENTE: mesma titularidade (CNPJ/Razão Social)
                      que consta no contrato de parceria<br />
                      CNPJ DO TITULAR DA CONTA CORRENTE: mesma titularidade (CNPJ/Razão Social) que consta no contrato de
                      parceria<br />
                    </p>
                    <h5>Dados para emissão da NF</h5>
                    <p v-if="polo.codColigada == 4">
                      <strong>RAZÃO SOCIAL:</strong> MULTIVIX SERRA - ENSINO PESQUISA E EXTENSÃO LTDA <br />
                      <strong>CNPJ/MF:</strong> 11.062.400/0001-48 <br />
                      <strong>ENDEREÇO:</strong> Rua Barão do Rio Branco, nº 120, Bloco 01 Térreo, Colina de Laranjeiras,
                      Serra-ES. <br />
                      <strong>CEP:</strong> 29.167-172
                    </p>
                    <p v-else-if="polo.codColigada == 2">
                      <strong>RAZÃO SOCIAL:</strong> MULTIVIX NOVA VENECIA - ENSINO, PESQUISA E EXTENSAO LTDA <br />
                      <strong>CNPJ/MF:</strong> 03.963.577/0001-97 <br />
                      <strong>ENDEREÇO:</strong> Rua Jacobina, 165, Bairro São Francisco - Nova Venécia-ES. <br />
                      <strong>CEP:</strong> 29.830-000
                    </p>
                    <h5>
                      A descrição do serviço deve constar conforme CLÁUSULA
                      PRIMEIRA do contrato:
                    </h5>
                    <strong class="mb-0"><em>Serviços de manutenção de Polo de Apoio Presencial com
                        atividades administrativas e educacional.</em></strong>
                    <br />
                    <br />
                    <!-- <p>
                      <i class="bx bx-phone font-size-16 align-middle me-2"></i>
                      Financeiro <a href="tel:02733355641">(27) 3335-5641</a>
                    </p> -->
                  </div>
                </b-modal>
                <div class="btn">
                  <button type="button" class="btn btn-primary" @click="analitico(repasse.codCampus)">
                    <i class="far fa-list-alt d-block font-size-16"></i>
                    Repasse Analítico
                  </button>
                </div>
                <b-modal id="modal-analitico" size="xl" title="Repasse Analítico" title-class="font-18" hide-footer
                  v-model="modalAnalitico">
                  <div class="col-12" v-if="loadingAnalitico">
                    <i class="
                                bx bx-loader bx-spin
                                font-size-16
                                align-middle
                                me-2
                              "></i>
                    Buscando...
                  </div>
                  <div class="col-12" v-else>
                    <div class="button-items">
                      <download-excel class="btn btn-default" :data="datatableItems" worksheet="Repasse"
                        name="repasse-analitico.xls">
                        <button type="button" class="btn btn-primary">
                          <i class="
                                      bx bx-download
                                      font-size-16
                                      align-middle
                                      me-2
                                    "></i>
                          Exportar para Excel
                        </button>
                      </download-excel>
                    </div>
                    <div id="tickets-table_filter" class="dataTables_filter">
                      <label class="d-inline-flex align-items-center">
                        Filtrar:
                        <b-form-input v-model="filter" type="search" placeholder="Digite para filtrar..."
                          class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table bordered striped hover dblclick class="datatables" :items="datatableItems" :fields="fields"
                        responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn"
                        @filtered="onFiltered"></b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                  ">
                          <ul class="pagination pagination-rounded mb-0">
                            <DatatablePaginationTotais :rows="rows" :totalRows="totalRows" :currentPage="currentPage"
                              :perPage="perPage"></DatatablePaginationTotais>
                            <b-pagination v-model="currentPage" :total-rows="rows > totalRows ? totalRows : rows"
                              :per-page="perPage"></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-modal>
                <download-excel class="btn" :data="[repasse]" worksheet="Repasse" name="repasse.xls">
                  <button type="button" class="btn btn-primary">
                    <i class="bx bx-download font-size-16 align-middle me-2"></i>
                    Exportar para Excel
                  </button>
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row" v-if="mostrarRepasse && repasse.master.polos.length > 0">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Repasses Polo Master</h4>
            <p class="card-title-desc">
              Clique no Polo para abrir o repasse analítico
            </p>
            <!-- <apexchart v-show="chart"
                      class="apex-charts"
                      height="400"
                      type="line"
                      dir="ltr"
                      :series="OveviewChart.series"
                      :options="OveviewChart.chartOptions"
                    ></apexchart> -->
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Polo</th>
                    <th>Status</th>
                    <th>Valor Baixado</th>
                    <th>Percentual</th>
                    <th>Repasse Responsável</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="polo in repasse.master.polos" v-bind:key="polo.polo" style="cursor: pointer"
                    @click="analitico(polo.codCampus)">
                    <td>{{ polo.polo }}</td>
                    <td>{{ polo.status }}</td>
                    <td>{{ $conversorMoeda(polo.valorBaixado) }}</td>
                    <td>{{ polo.percentual }}%</td>
                    <td>{{ $conversorMoeda(polo.repasseResponsavel) }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <strong>{{ $conversorMoeda(repasse.master.total) }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div class="row">
              <div class="button-items">
                <download-excel class="btn" :data="repasse.master.polos" worksheet="Repasse" name="repasse-master.xls">
                  <button type="button" class="btn btn-primary">
                    <i class="bx bx-download font-size-16 align-middle me-2"></i>
                    Exportar para Excel
                  </button>
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="mostrarRepasse && repasse.gastos.itens.length > 0">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Gastos do Polo</h4>
            <!-- <p class="card-title-desc"> 
                      Clique no Polo para abrir o repasse analítico
                    </p> -->
            <!-- <apexchart v-show="chart"
                      class="apex-charts"
                      height="400"
                      type="line"
                      dir="ltr"
                      :series="OveviewChart.series"
                      :options="OveviewChart.chartOptions"
                    ></apexchart> -->
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Competência</th>
                    <th>Item</th>
                    <th>Valor</th>
                    <th>Vencimento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in repasse.gastos.itens" v-bind:key="item">
                    <td>{{ item.competencia }}</td>
                    <td>{{ item.item }}</td>
                    <td>{{ $conversorMoeda(item.valor) }}</td>
                    <td>{{ item.vencimento }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>
                      <strong>{{ $conversorMoeda(repasse.gastos.total) }}</strong>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div class="row">
              <div class="button-items">
                <download-excel class="btn" :data="repasse.gastos.itens" worksheet="Gastos" name="gastos.xls">
                  <button type="button" class="btn btn-primary">
                    <i class="bx bx-download font-size-16 align-middle me-2"></i>
                    Exportar para Excel
                  </button>
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="css" scoped>
.row-pointer>>>tbody tr :hover {
  cursor: pointer;
}
</style>